import Reveal from "@/components/base/Reveal";
import { useContent } from "@/content/ContentProvider";

export default function Teachers() {
  const teachers = useContent("about.teachers");

  return (
    <section id="teachers" className="scroll-mt-24 bg-background-100 py-20 md:py-28">
      <div className="mx-auto max-w-content px-5 md:px-8">
        <Reveal className="max-w-2xl">
          <span className="font-label text-xs tracking-[0.25em] text-primary-600">
            TEACHERS
          </span>
          <h2 className="mt-3 font-heading text-3xl font-black tracking-tight text-foreground-950 md:text-5xl">
            수학만 깊게 파고든
            <br />
            전문 강사진
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-700">
            학년과 영역별로 전문화된 선생님들이 학생 한 명 한 명의 성장을
            책임집니다.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {teachers.map((teacher, idx) => (
            <Reveal key={teacher.name} delay={idx * 70}>
              <article className="group h-full overflow-hidden rounded-2xl border border-background-200 bg-background-50">
                <div className="aspect-[4/5] w-full overflow-hidden">
                  <img
                    src={teacher.image}
                    alt={`${teacher.name} 선생님 프로필 이미지`}
                    className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center justify-between">
                    <h3 className="font-heading text-lg font-black text-foreground-950">
                      {teacher.name}
                    </h3>
                    <span className="rounded-full bg-accent-100 px-2.5 py-1 font-label text-[10px] font-bold text-accent-700">
                      {teacher.career}
                    </span>
                  </div>
                  <p className="mt-1 text-sm font-bold text-primary-600">{teacher.role}</p>
                  <p className="mt-0.5 font-label text-[11px] text-foreground-600">
                    {teacher.specialty}
                  </p>
                  <p className="mt-3 text-xs leading-relaxed text-foreground-700">
                    {teacher.desc}
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}